import { constants } from "redux/constants/redux-constants";

export const setNJTemplateUser = (payload) => ({
    type: constants.IS_NJ_TEMPLATE_USER, 
    payload: payload,
});